import { Box, Typography, Paper, Grid, Chip } from '@mui/material';
import React, { useState, useEffect } from 'react';

import CreateSectionButton from './CreateSectionButton';
import SectionBulkActions from './SectionBulkActions';
import SectionCardList from './SectionCardList';
import SectionSearchBar from './SectionSearchBar';
import SectionsTreeView from './SectionsTreeView';

const SectionsPage = () => {
  const [selectedSection, setSelectedSection] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [stats, setStats] = useState({ totalSections: 0, activeSections: 0, totalItems: 0 });

  // Placeholder para estatísticas (pode ser implementado com dataProvider)
  useEffect(() => {
    // Aqui você pode fazer chamadas para buscar estatísticas
    setStats({ totalSections: 0, activeSections: 0, totalItems: 0 });
  }, []);

  return (
    <Box display="flex" flexDirection="column" height="100vh">
      {/* Header com Título e Estatísticas */}
      <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
        <Typography variant="h4" gutterBottom>
          Gerenciamento de Seções
        </Typography>
        <Grid container spacing={2}>
          <Grid item>
            <Chip 
              label={`${stats.totalSections} Seções Total`} 
              color="primary" 
              variant="outlined" 
            />
          </Grid>
          <Grid item>
            <Chip 
              label={`${stats.activeSections} Ativas`} 
              color="success" 
              variant="outlined" 
            />
          </Grid>
          <Grid item>
            <Chip 
              label={`${stats.totalItems} Itens`} 
              color="info" 
              variant="outlined" 
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Conteúdo Principal */}
      <Box display="flex" flexGrow={1}>
        <Paper elevation={1} sx={{ width: '300px', mr: 2, p: 2 }}>
          <SectionSearchBar onSearch={setSearchQuery} />
          <SectionsTreeView
            selected={selectedSection}
            onSelect={setSelectedSection}
            searchQuery={searchQuery}
          />
          <SectionBulkActions selected={selectedSection} />
        </Paper>
        
        <Box flexGrow={1}>
          <SectionCardList sectionId={selectedSection} />
        </Box>
      </Box>
      
      <CreateSectionButton />
    </Box>
  );
};

export default SectionsPage;
